import React, { useState } from "react";
import styled from "styled-components";
import NotCheckedSvg from "../../asserts/img/Checkbox.svg";
import CheckedSvg from "../../asserts/img/checked.svg";

const CheckboxContainer = styled.div`
  flex: 1;
  margin-left: 0.5em;
  margin-right: 0.5em;
`;

const Label = styled.div(({ theme }) => ({
  fontSize: 13,
  color: theme.color.label,
  textAlign: "start",
  fontWeight: 600,
  marginBottom: 5,
  whiteSpace: "nowrap",
}));

const Checkbox = ({
  width,
  height,
  checked,
  onChange,
  label,
  error,
  inline,
  disabled = false,
  ...props
}) => {
  const defaultChecked = checked ? checked : false;
  const [isChecked, setChecked] = useState(defaultChecked);
  return (
    <CheckboxContainer
      style={{ ...props.style }}
      onClick={() => {
        if (disabled) return;
        setChecked((checked) => !checked);
        onChange(isChecked);
      }}>
      {!inline && !!label && <Label>{label}</Label>}
      <div
        style={{
          alignItems: "center",
          display: "flex",
          alignSelf: "center",
        }}>
        {isChecked ? (
          <img
            src={CheckedSvg}
            style={{ width: 18, height: 18 }}
            alt="Checked"
          />
        ) : (
          <img
            src={NotCheckedSvg}
            style={{ width: width, height: height }}
            alt="not_checked"
          />
        )}
        {inline && !!label && (
          <Label style={{ marginBottom: 0, marginInlineStart: 20 }}>
            {label}
          </Label>
        )}
      </div>
    </CheckboxContainer>
  );
};

export default Checkbox;
